  import { useState, useEffect, useRef } from 'react';
  import { useTranslation } from 'react-i18next';
  import { FiChevronDown } from 'react-icons/fi';
  import 'flag-icons/css/flag-icons.min.css';

  export default function LanguageSwitcher({ isMobile = false }) {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const languages = [
      { code: 'es', name: 'Español', countryCode: 'mx', nativeName: 'Español' },
      { code: 'en', name: 'English', countryCode: 'us', nativeName: 'English' },
    ];

    const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleLanguageChange = (langCode) => {
      i18n.changeLanguage(langCode);
      setIsOpen(false);
    };

    return (
      <div className={`relative ${isMobile ? 'w-full' : ''}`} ref={dropdownRef}>
        {/* Dropdown Button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={`
            flex items-center gap-2 px-3 py-2 rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2
            ${isMobile 
              ? 'w-full justify-between bg-white border border-gray-300 hover:border-gray-400' 
              : 'bg-black border border-black hover:border-gray-500'
            }
          `}
        >
          <div className="flex items-center gap-2">
            <span className={`fi fi-${currentLanguage.countryCode} fis rounded-sm`}></span>
            {isMobile && (
              <span className="text-sm font-medium text-gray-700">
                {currentLanguage.name}
              </span>
            )}
          </div>
          <FiChevronDown className={`w-4 h-4 ${isMobile ? 'text-gray-500' : 'text-gray-500'} transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
        </button>

        {/* Dropdown Menu */}
        {isOpen && (
          <div 
            className={`
              absolute mt-2 w-48 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-50
              ${isMobile ? 'right-0 bg-white' : 'right-0 bg-black'}
            `}
          >
            <div className="py-1" role="menu" aria-orientation="vertical">
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  onClick={() => handleLanguageChange(lang.code)}
                  className={`
                    w-full text-left px-4 py-2 text-sm flex items-center gap-3
                    transition-colors duration-150
                    ${isMobile 
                      ? (i18n.language === lang.code 
                        ? 'bg-indigo-50 text-indigo-700' 
                        : 'text-gray-700 hover:bg-gray-50')
                      : (i18n.language === lang.code 
                        ? 'bg-gray-700 text-white' 
                        : 'text-gray-200 hover:bg-gray-700')
                    }
                  `}
                  role="menuitem"
                >
                  <span className={`fi fi-${lang.countryCode} fis rounded-sm`}></span>
                  <div className="flex flex-col">
                    <span className={`font-medium ${isMobile ? 'text-gray-900' : ''}`}>
                      {lang.name}
                    </span>
                  </div>
                  {i18n.language === lang.code && (
                    <svg 
                      className={`w-4 h-4 ml-auto ${isMobile ? 'text-indigo-600' : 'text-white'}`} 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  )}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }